import type { api } from '@iobroker/dm-utils';

export type {
    ActionButton,
    ConfigConnectionType,
    ControlBase,
    ControlState,
    DeviceDetails,
    DeviceId,
    DeviceStatus,
    ErrorResponse,
    JsonFormSchema,
    ProgressUpdate,
} from '@iobroker/dm-utils';

export type ActionBase = api.ActionBase;
export type CommunicationForm = api.CommunicationForm;
export type DeviceAction = api.DeviceAction;
export type DeviceControl = api.DeviceControl;
export type DeviceInfo = api.DeviceInfo;
export type DeviceLoadIncrement = api.DeviceLoadIncrement;
export type DmActionResponse = api.DmActionResponse;
export type DmControlResponse = api.DmControlResponse;
export type InstanceAction = api.InstanceAction;
export type InstanceDetails = api.InstanceDetails;
export type InstanceRefreshResponse = api.InstanceRefreshResponse;
